define([
	"dojo/store/Memory"
], function(Memory) {

	return new Memory({
		data: [
			{name: "20", id: "20", value: 20},
			{name: "50", id: "50", value: 50},
			{name: "100", id: "100", value: 100},
			{name: "200", id: "200", value: 200}
		]
	});
});